import { AxiosInstance } from 'axios';

import { FormName } from '@topconagriculture/feed-types';

import { FeedingPeriod, FeedingPeriodWithFeedings } from '../../../store/entities/feeding/feeding.types';
import { APIManagerConfig } from '../apiManager';
import { FeedingPeriodUpdate } from './feeding.types';

const FeedingServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    fetchFeedingPeriodList: (): Promise<FeedingPeriod[]> =>
      HTTPBase.get(`farm/${config.farmId}/feedingperiods`).then((res) => res.data),
    fetchFeedingPeriodListWithFeedings: (): Promise<FeedingPeriod[]> =>
      HTTPBase.get(`farm/${config.farmId}/feedingperiods?includefeedings=true`).then((res) => res.data),
    fetchFeedingPeriodDetail: (id: number): Promise<FeedingPeriodWithFeedings> =>
      HTTPBase.get(`farm/${config.farmId}/feedingperiods/${id}`).then((res) => res.data),
    fetchLoadList: (
      mixers: number[],
      unitmode: 'scale' | 'user',
      feedingPeriodsNo?: number[],
      listMode?: boolean,
      effectiveDate?: Date,
    ) =>
      HTTPBase.get(`farm/${config.farmId}/feedings/${listMode ? 'loaddata' : 'loads'}`, {
        params: {
          periods: feedingPeriodsNo && feedingPeriodsNo.join(','),
          mixers: mixers.join(','),
          unitmode,
          effectiveDate,
        },
      }).then((res) => res.data),
    fetchPresetList: (): Promise<any> => HTTPBase.get(`farm/${config.farmId}/feedings/presets`).then((res) => res.data),
    updateFeedingOrderInPeriod: (
      id: string,
      feedingPeriods: { id: string; feedings: { id: string }[] },
      formName: FormName,
    ) =>
      HTTPBase.patch(`farm/${config.farmId}/feedingperiods/${id}`, feedingPeriods, { headers: { formName } }).then(
        (res) => res.data,
      ),
    updateFeedingPeriod: (id: number, data: FeedingPeriodUpdate, formName: FormName) =>
      HTTPBase.patch(`farm/${config.farmId}/feedingperiods/${id}`, data, { headers: { formName } }).then(
        (res) => res.data,
      ),
    sendFeedingLoadsToMixer: (
      feedingPeriodsNo: number[],
      mixers: number[],
      channel: string,
      formName: FormName,
      effectiveDate?: string,
    ) =>
      HTTPBase.post(`farm/${config.farmId}/feedings/send`, null, {
        params: {
          periods: feedingPeriodsNo.join(','),
          mixers: mixers.join(','),
          channel,
          effectivedate: effectiveDate,
          headers: { formName },
        },
      }).then((res) => res.data),
    createFeedingPeriod: (data: Partial<FeedingPeriodUpdate>, formName: FormName) =>
      HTTPBase.post(`farm/${config.farmId}/feedingperiods`, data, { headers: { formName } }).then((res) => res.data),
    deleteFeedingPeriod: (id: string, formName: FormName) =>
      HTTPBase.delete(`farm/${config.farmId}/feedingperiods/${id}`, { headers: { formName } }).then((res) => res.data),
  };
};

export default FeedingServiceFactory;
